import { RouteConfig } from 'vue-router';
import { ROUTE_NAMES } from '@/ui/constant/routes.constants';

const PATHS: Record<string, string> = {
  SHARE_MEDIA: '/share/:secret',
};

export const ROUTE_SHARE_MEDIA: RouteConfig = {
  path: PATHS.SHARE_MEDIA,
  name: ROUTE_NAMES.SHARE_MEDIA,
  component: () => import('@/ui/views/ShareMediaView.vue'),
  props: true,
};
